import { hotTopics } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function HotTopics() {
  return (
    <section id="topics" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热门话题"
          title="同好们正在聊什么"
          desc="每天都有大量同好在这里展开热烈讨论，找同好、聊剧情、分享心头好，热门话题一站直达。"
        />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="flex items-center justify-between gap-3">
                <span className={`inline-flex items-center whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${colorMap[topic.color]}`}>
                  {topic.tag}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-fire-line text-sm text-primary-500"></i>
                  {topic.heat.toLocaleString()}
                </span>
              </div>

              <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {topic.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {topic.snippet}
              </p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-user-heart-line text-[11px]"></i>
                  </span>
                  {topic.author}
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-chat-3-line text-sm"></i>
                  {topic.replies} 回复
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#discussion"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            浏览全部讨论
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}